// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';

const StepTransitionLink = ({ pageBabyStep, userBabyStep, authToken }) => {
  if (pageBabyStep > userBabyStep) {
    return null;
  }

  const buttonText =
    pageBabyStep === userBabyStep
      ? 'I’m done with this step.'
      : 'I’m back on this step.';

  // This mimics the rails simple form setup so that we can do an AJAX PUT request.
  // StimulusJS will handle the redirect/page updates.
  return (
    <div className="BabyStepDetailCard-footer">
      <form
        action="/api/baby-step"
        data-action="ajax:success->track#updateBabyStep"
        data-remote="true"
        method="post"
      >
        <input type="hidden" name="_method" value="put" />
        <input type="hidden" name="authenticity_token" value={authToken} />
        <input type="hidden" name="step" value="2" />
        <button
          className="rds-Button rds-Button--subtle"
          data-testid="StepTransitionLink"
        >
          {buttonText}
        </button>
      </form>
    </div>
  );
};

StepTransitionLink.propTypes = {
  pageBabyStep: PropTypes.string,
  userBabyStep: PropTypes.string,
  authToken: PropTypes.any
};

export default StepTransitionLink;
